import { usePermissionCheck } from './useHasPermission';

function WithPermissions({
  children,
  permission,
  rbacPermission,
  resourceType,
  resourceId,
  anyScope = false,
  fallback = null
}) {
  const { allowed, loading } = usePermissionCheck({
    permission,
    rbacPermission,
    resourceType,
    resourceId,
    anyScope
  });

  if (loading) {
    return <>{fallback}</>;
  }

  return allowed ? <>{children}</> : <>{fallback}</>;
}

export default WithPermissions;
